var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-SRHR-button"},[_c('SmallButton',{on:{"click":_vm.showAboutSRHR}},[_vm._v("\n    Läs mer om SRHR\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }